// CANONICAL COPY (GH #7115). src/constants/obligations/obl-nda-signed.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-nda-signed',
  title: 'Verify confidentiality agreements are signed',
  description:
    'Confirm that all employees and relevant third parties have signed confidentiality/NDA agreements. Either a verified nda-signed evidence record or the joiner JML NDA checkbox satisfies this obligation.',
  category: 'people',
  scfIds: ['SCF-PPL-006'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'evidence-requirement-met',
      evidenceType: 'nda-signed',
      description: 'Verified, in-date NDA evidence record for every employee in scope',
    },
    {
      type: 'employees-nda-signed',
      description: 'Every active employee has nda-signed in a JML joiner checklist',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'employees', label: 'Review Employee Records' }],
};
